import React, { useEffect, useState } from 'react';
import FormField from '@ingka/form-field';
import Combobox, { MenuItem } from '@ingka/combobox';
import Tooltip from '@ingka/tooltip';
import './multiSelect.scss';
const MultiSelect = (props: any) => {
  const [selectedItems, setSelectedItems] = useState([]);

  const sanitizeId = (name: string) => name.replace(/[^a-zA-Z0-9]/g, '-');

  const idToNameMap = props.item.reduce((acc: any, name: string) => {
    acc[sanitizeId(name)] = name;
    return acc;
  }, {});

  useEffect(() => {
    if (props.tabChange) {
      setSelectedItems([]);
      props.comboFilter([]);
    }
  }, [props.tabChange]);

  const handleListBoxChange = (selectedIds: string[]) => {
    const selectedNames = selectedIds.map((id) => idToNameMap[id]);
    setSelectedItems(selectedNames);
    props.comboFilter(selectedNames);
  };

  const getTruncatedMessage = () => {
    const fullMessage = `Selected Items: ${selectedItems.join(', ')}`;
    if (fullMessage.length > 20) {
      return `${fullMessage.slice(0, 20)}...`;
    }
    return fullMessage;
  };
  return (
    <FormField
      fieldHelper={{
        id: 'helper-msg-id',
        msg: (
          <Tooltip
            describedById="tooltip-example"
            position="top"
            tooltipText={`Selected Items: ${selectedItems.join(', ')}`}
          >
            <span>{getTruncatedMessage()}</span>
          </Tooltip>
        ),
        type: '',
      }}
      valid="error"
      validation={{
        id: 'error-msg-id',
        msg: 'Validation msg text',
        type: 'error',
      }}
    >
      <Combobox
        className="combobox-story"
        labelId="label-id"
        listboxId="combobox-listbox"
        multiple
        filtering
        onListBoxChange={handleListBoxChange}
        onMouseLeave={() => {
          props.comboFilter(selectedItems);
        }}
        placeholder="Select Suppliers"
        onClearClicked={() => {
          setSelectedItems([]);
          props.comboFilter([]);
        }}
      >
        {props?.item?.map((item: any) => (
          <MenuItem key={sanitizeId(item)} id={sanitizeId(item)} title={item} />
        ))}
      </Combobox>
    </FormField>
  );
};

export default MultiSelect;
